export default __webpack_public_path__ + "static/media/checkout.8cd64007.svg";